<template>
  <div>
    <div class="door-modal-header">
      <p>{{ modalHeader }}</p>
    </div>

    <div class="door-modal-content">
      <!-- <p> -->
      <!-- begin::Open door -->
      <p
        v-if="actionType == actions.open_door"
        v-html="
          $t('sitesAndDevices.kioskActions.openDoorConfirm', {
            kiosk: kioskInfo.kiosk_name,
          })
        "
      />
      <!-- end::Open door -->

      <!-- begin::restart app -->
      <p
        v-else-if="actionType == actions.restart_app"
        v-html="
          $t('sitesAndDevices.kioskActions.restartAppConfirm', {
            kiosk: kioskInfo.kiosk_name,
          })
        "
      />
      <!-- end::restart app -->

      <!-- begin::restart kiosk -->
      <p v-else-if="actionType == actions.restart_kiosk"  v-html="
          $t('sitesAndDevices.kioskActions.restartKioskConfirm', {
            kiosk: kioskInfo.kiosk_name,
          })
        "
      />
      <!-- end::restart kiosk -->
      <!-- </p> -->
    </div>

    <hr class="separate-line" />

    <div class="door-modal-footer">
      <div class="d-flex justify-content-between">
        <button class="btn-action btn-action-open" @click="submitAction()">
          {{ btnValue }}
        </button>
        <button
          class="btn-action btn-action-cancel"
          @click="$bvModal.hide('kioskActions' + kioskInfo.mac_address)"
        >
          {{ $t("common.cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      btnValue: null,
      modalHeader: null,
      actions: {
        open_door: "open_door",
        restart_app: "restart_app",
        restart_kiosk: "restart_kiosk",
      },
      actionType: null,
      kioskInfo: null,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  beforeMount() {
    this.actionType = this.getModalInfo.actionType;
    this.kioskInfo = this.getModalInfo.kioskInfo;

    switch (this.actionType) {
      case this.actions.open_door:
        this.modalHeader = this.$t("sitesAndDevices.kioskActions.openDoor");
        this.btnValue = this.$t('common.open');
        break;
      case this.actions.restart_app:
        this.modalHeader = this.$t("sitesAndDevices.kioskActions.restartApp");
        this.btnValue = this.$t('common.restart');
        break;
      case this.actions.restart_kiosk:
        this.modalHeader = this.$t("sitesAndDevices.kioskActions.restartKiosk");
        this.btnValue = this.$t('common.restart');
        break;
    }
  },
  methods: {
    ...mapActions("daemon", ["pushRestart", "restartApp", "openDoor"]),
    submitAction() {
      switch (this.actionType) {
        case this.actions.open_door:
          this.openDoor(this.kioskInfo);
          break;
        case this.actions.restart_app:
          this.restartApp(this.kioskInfo);
          break;
        case this.actions.restart_kiosk:
          this.pushRestart(this.kioskInfo);
          break;
      }
      this.$bvModal.hide("kioskActions" + this.kioskInfo.mac_address);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .door-modal-header {
    font-weight: 700;
    font-size: 17px;
    line-height: 20.4px;
    margin-bottom: 17px;
    margin-inline-start: -10px;
    padding-top: 30px;
    padding-inline-end: 0px;
    padding-bottom: 0px;
    padding-inline-start: 30px;
  }

  .door-modal-content {
    width: 420px;
    margin: auto;
    color: #787878;
    p {
      font-weight: 400;
      font-size: 17.5px;
      line-height: 33px;
      margin-bottom: 17px;
      text-align: center;
      b {
        font-weight: 700;
      }
    }
  }

  .separate-line {
    width: 420px;
    margin: 25px auto 20px;
  }
  .door-modal-footer {
    width: 250px;
    margin: auto;
    .btn-action {
      width: 111px;
      height: 33px;
      border: none;
      border-radius: 26px;

      font-weight: 400;
      line-height: 19.2px;
      text-align: center;
    }
    .btn-action.btn-action-open {
      background-color: #103f5e;
      color: #ffffff;
    }
    .btn-action.btn-action-cancel {
      border: 1px solid #f46a6a !important;
      color: #f46a6a;
      background-color: #ffffff;
    }
  }
}
</style>
